export default {
  login: {
    passwordResetSentAlertLabel:
      'That worked! Please check your email and follow the instructions.',
    title: 'Logging in...',
    button: 'Log in',
    form: {
      email: 'Your email address',
      password: 'Your password',
    },

    message: {
      success: 'Perfect. You are logged in.',
      error: 'Whoops, there was an error. Please try again.',
    },

    forgotPassword: {
      title: 'Reset password',
      button: 'Forgot your password?',
      form: {
        email: 'Email',
        submitButton: 'Reset password',
      },
      passwordResetSent:
        'We sent you an email for password reset. Please check your inbox.',
    },
  },
}
